import './Fleet.css'
import sedan from '../../images/corola1.png'
import bag from '../../images/bag2.png'
import air from '../../images/toto2.png'
import seats from '../../images/seat1.png'
import suv from '../../images/suv.png'
import grand from '../../images/grand.webp'
import h1 from '../../images/download.png'
import his from '../../images/b2.png'
import coaster from '../../images/coaster1.png'
import Swiper from '../../components/swiper/Swiper'


function Fleet() {
  return (
   <>
     <div className='fleet'>
        <div className="grid">
            <div className="text">
                <p>We Are Creating A World Where</p>
                <h1>Our Fleet Ensures <span> Your Journey</span></h1>
                <span className="new">Travel to your next destination in comfort and with complete peace of mind with Comfort Limo.</span>
            </div>
        </div>
    </div>
    <div className="types pt-5">
        <div className="container-fluid pt-5">
            <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="one">
                        {/* <img src={icon} alt=""  className='icon'/> */}
                        <h3>SEDAN</h3>
                        
                        <img src={sedan} alt="sedan" className='sedan'/>
                        <p className='car'>Toyota, Elentra ,Kia & Similar Starting From 2021</p>
                        <hr />
                        <div className="bottom">
                            <span>Features</span>
                            <ul>
                                <li>
                                    <img src={bag} alt="bag" />
                                    <p className='m-0'>1 Large Bag + 1 Small Bag</p>
                                </li>
                                <li>
                                   <img src={air} alt="" />
                                    <p className='m-0'>Air Conditioning</p>
                                </li>
                                <li>
                                    <img src={seats} alt="seats"/>
                                    <p className='m-0'>3 Seats</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="one">
                        <h3>SUV</h3>
                        <img src={suv} alt="suv" className='suv'/>
                        <p className='car suv'>Tucson, Sportage ,MG zs & Similar Starting From 2021</p>
                        <hr />
                        <div className="bottom">
                            <span>Features</span>
                            <ul>
                                <li>
                                    <img src={bag} alt="bag" />
                                    <p className='m-0'>3 Large Bag + 2 Small Bag</p>
                                </li>
                                <li>
                                    <img src={air} alt="air" />
                                    <p className='m-0'>Air Conditioning</p>
                                </li>
                                <li>
                                    <img src={seats} alt="seats" />
                                    <p className='m-0'>4 Seats</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="one">
                        <h3>SUV Grand</h3>
                        <img src={grand} alt="grand" className='grand' />
                        <p className='car grand'>Xpander, Glory ,Ortega & Similar Starting From 2021</p>
                        <hr />
                        <div className="bottom">
                            <span>Features</span>
                            <ul>
                                <li>
                                    <img src={bag} alt="bag" />
                                    <p className='m-0'>3 Large Bag + 2 Small Bag</p>
                                </li>
                                <li>
                                    <img src={air} alt="air" />
                                    <p className='m-0'>Air Conditioning</p>
                                </li>
                                <li>
                                    <img src={seats} alt="seats" />
                                    <p className='m-0'>6 Seats</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="one">
                        <h3>Mini Van</h3>
                        <img src={h1} alt="h1" className='h1'/>
                        <p className='car'>Hyundai H1 Starting From 2020</p>
                        <hr />
                        <div className="bottom">
                            <span>Features</span>
                            <ul>
                                <li>
                                    <img src={bag} alt="bag" />
                                    <p className='m-0'>6 Large Bag</p>
                                </li>
                                <li>
                                    <img src={air} alt="air" />
                                    <p className='m-0'>Air Conditioning</p>
                                </li>
                                <li>
                                    <img src={seats} alt="seats" />
                                    <p className='m-0'>From 7 to 9 Seats</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="one">
                        <h3>Van</h3>
                        <img src={his} alt="his" className='his'/>
                        <p className='car'>Toyota HIAS Starting From 2022 </p>
                        <hr />
                        <div className="bottom">
                            <span>Features</span>
                            <ul>
                                <li>
                                    <img src={bag} alt="bag" />
                                    <p className='m-0'>13 Large Bag</p>
                                </li>
                                <li>
                                    <img src={air} alt="air" />
                                    <p className='m-0'>Air Conditioning</p>
                                </li>
                                <li>
                                    <img src={seats} alt="seats" />
                                    <p className='m-0'>13 Seats</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="one">
                        <h3>Coaster</h3>
                        <img src={coaster} alt="coaster" className='coaster' />
                        <p className='car'>Toyota Coaster Starting From 2020</p>
                        <hr />
                        <div className="bottom">
                            <span>Features</span>
                            <ul>
                                <li>
                                    <img src={bag} alt="bag" />
                                    <p className='m-0'>24 Large Bag </p>
                                </li>
                                <li>
                                    <img src={air} alt="air" />
                                    <p className='m-0'>Air Conditioning</p>
                                </li>
                                <li>
                                    <img src={seats} alt="seats" />
                                    <p className='m-0'>From 22 To 24 Seats</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <h2 className='customer'>Customer's  <span> Reviews</span></h2>
     <Swiper/>
   </>
  )
}

export default Fleet